import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=73221729&scoped=true&"
import script from "./EmployeeForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=73221729&prod&lang=scss&scoped=true&"
import style1 from "./EmployeeForm.vue?vue&type=style&index=1&id=73221729&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73221729",
  null
  
)

export default component.exports